<template>
	<div class="body-mobile">
		<div class="wrapper-body">
			<div class="wrapper-body__header">
				<nav-step :active="1"></nav-step>
			</div>
			<div class="wrapper-body__body">
				<div class="wrapper-body__body__title">
					<p>{{sysName}}须知</p>
				</div>
				<div class="wrapper-body__body__container">
					<div class="no_style_textarea" v-if="signupData">
						{{signupData.content}}
					</div>
				</div>
			</div>
			<div class="wrapper-body__footer">
				<div class="box-btns" v-if="signupData">
					<span class="button-primary" @click="handlePreviousStep">上一步</span>
					<a v-if="isReadNotes" class="button-primary-inset" href="javascript:void(0)">已阅 下一步 ({{sendCodeSecond+1}}s)</a>
					<a v-else class="button-primary-inset" @click="onClickGoLogin">下一步</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import IndexCommon from '../index/mixins/index_common';
	import MobileCommon from '../index/mixins/mobile_common';
	import PageBmNotes from '../index/mixins/page_bm_notes';

	export default {
		mixins: [IndexCommon, MobileCommon, PageBmNotes],
		components: {},
		data() {
			return {
			}
		},

		mounted() {
		},

		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
	.body-mobile
		background-image url('./images/bg1.png');
	.no_style_textarea
		white-space pre-line
		min-height 400px
		text-indent 2em
		font-weight 100
		width 100%
		padding 10px
		font-size 20px
		color #000
		line-height 2.2em
		background none
		border 0
</style>
